import React from "react";
import { Survey, SurveyReportDataSet, SurveySegment, surveyHelper } from "../../../../../../../amorg-common";
import { Flex } from "../../../../../../../designSystem/compositeComponents/FlexHelpers";
import { PageSection } from "../../../../../../../designSystem/PageSection";
import { ReportSummarySection } from "../../_components/ReportSummarySection";
import { IndicatorPanel } from "./IndicatorPanel";
import { ThemePanel } from "./ThemePanel";

type SurveyReportPanelProps = {
    survey: Survey,
    siteId:string,
    data:SurveyReportDataSet,
    segments:SurveySegment[][]
    showComments: boolean,
};
export function SurveyReportPanel (props: SurveyReportPanelProps): JSX.Element
{
    const hasLoaded = props.survey && props.data;
    const hasQuestions = hasLoaded && surveyHelper.getAllSurveyQuestions(props.survey).length > 0;

    return (
        <>
            {hasLoaded && hasQuestions &&
                <>
                    <Flex flexDirection="column" gap={16}>

                        <ReportSummarySection survey={props.survey} data={props.data} expandable />

                        <PageSection headerStyleVariant="card" contentStyleVariant="card"
                            header={{ title: 'Spørgsmål fordelt på Tema',
                                defaultCollapsed: true
                             }}>

                            <ThemePanel
                                survey={props.survey}
                                siteId={props.siteId}
                                themes={props.data.themeData}
                                segmentFilter={props.segments}
                                showComments={props.showComments} />
                        </PageSection>

                        {props.survey.themes.some(t => t.questions.some(q => q.indicators.length > 0)) &&
                            <PageSection headerStyleVariant="card" contentStyleVariant="card"
                                header={{ title: 'Indikatorer', defaultCollapsed: true }}>
                                <IndicatorPanel
                                    survey={props.survey}
                                    siteId={props.siteId}
                                    data={props.data.indicatorData}
                                    segmentFilter={props.segments}
                                    showComments={props.showComments} />
                            </PageSection>
                        }
                    </Flex>
                </>
            }
        </>
    );
}